import React from "react"
import { Layout } from "antd"
import { Outlet } from "react-router-dom"

export const ProCalendarLayout = () => {
  return (
    <Layout>
      <Outlet />
    </Layout>
  )
}
